export function isBlankCountedQty(value) {
  return value === '' || value == null;
}
